var _mask, _path, _path2, _rect, _path3, _path4, _ellipse, _ellipse2, _path5, _path6, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _path7, _path8, _path9, _path0, _path1, _path10, _ellipse8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgIllustrationOtpBig = function SvgIllustrationOtpBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 357 357"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "illustration-otp-big_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m92.28 184.167 85.854-93.883c4.221-4.616 11.493-4.616 15.714 0l85.855 93.883v89.59c0 6.382-5.173 11.555-11.554 11.555H103.834c-6.381 0-11.554-5.173-11.554-11.555v-89.589z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp-big_svg__a)",
    fillRule: "evenodd",
    d: "m92.28 184.167 85.854-93.883c4.221-4.616 11.493-4.616 15.714 0l85.855 93.883v89.59c0 6.382-5.173 11.555-11.554 11.555H103.834c-6.381 0-11.554-5.173-11.554-11.555v-89.589z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp-big_svg__b)",
    d: "m178.134 90.284 1.599 1.462zM92.28 184.167l-1.599-1.462-.042.047-.04.048zm101.568-93.883-1.599 1.462zM92.28 184.168 90.6 182.8zm187.423-.001-1.599 1.462zM176.536 88.822l-85.855 93.883 3.198 2.924 85.854-93.883zm18.911 0c-5.08-5.555-13.831-5.555-18.911 0l3.197 2.924c3.362-3.676 9.154-3.676 12.516 0zm85.854 93.883-85.854-93.883-3.198 2.924 85.855 93.883zm-3.764 1.463v89.589h4.333v-89.589zm-9.388 98.977H103.834v4.333h164.315zm-173.703-9.388v-89.589h-4.332v89.589zM90.6 182.8zl3.361 2.735zm1.68-.799c1.826 0 2.833 2.118 1.681 3.534L90.6 182.8c-1.152 1.416-.145 3.534 1.68 3.534zm2.167 2.167c0-1.11-.885-2.167-2.166-2.167v4.333c-1.281 0-2.166-1.056-2.166-2.166zm9.388 98.977a9.388 9.388 0 0 1-9.388-9.388h-4.332c0 7.578 6.142 13.721 13.72 13.721zm173.703-9.388a9.388 9.388 0 0 1-9.388 9.388v4.333c7.578 0 13.721-6.143 13.721-13.721zm2.166-87.423a2.166 2.166 0 0 1-2.166-2.166h4.333a2.167 2.167 0 0 0-2.167-2.167zm-1.599-.705c.41.449.991.705 1.599.705v-4.333c.608 0 1.188.256 1.598.704z",
    mask: "url(#illustration-otp-big_svg__c)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140.706,
    height: 158.361,
    x: 116.232,
    y: 99.659,
    fill: "#fff",
    stroke: "url(#illustration-otp-big_svg__d)",
    strokeWidth: 1.331,
    rx: 9.981
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BFD3FF",
    d: "m257.919 145.646-136.995 30.406c-12.892 2.862-25.663-5.269-28.525-18.161-2.861-12.893 5.27-25.664 18.162-28.525l136.995-30.407c12.892-2.862 25.663 5.269 28.525 18.162 2.861 12.892-5.27 25.663-18.162 28.525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9CB9FC",
    d: "M123.067 159.41c-.744 1.042-1.736 1.702-2.974 1.977-.992.22-1.934.007-2.824-.64-.891-.646-1.446-1.466-1.666-2.457-.193-.867.041-1.862.703-2.984.66-1.122 2.481-2.435 5.462-3.943-3.29-.179-5.484-.619-6.582-1.317-1.097-.698-1.742-1.482-1.934-2.35-.22-.991-.064-1.968.47-2.932.534-.962 1.296-1.555 2.288-1.775 1.239-.275 2.412-.113 3.521.486a81.815 81.815 0 0 0 4.057 2.024 33.92 33.92 0 0 0-1.135-2.917c-.385-.856-.652-1.625-.804-2.308-.276-1.239-.174-2.317.305-3.236.479-.918 1.307-1.509 2.483-1.769 1.239-.275 2.281-.117 3.129.476.846.592 1.407 1.509 1.682 2.746.179.806.243 1.687.195 2.638a14.46 14.46 0 0 0 .185 3.03 149.251 149.251 0 0 1 2.939-3.675c.795-.956 1.75-1.558 2.865-1.805.991-.22 1.932-.006 2.824.64.89.649 1.446 1.468 1.666 2.457.193.868-.076 1.855-.806 2.958-.73 1.104-2.548 2.434-5.452 3.989 3.276.118 5.482.538 6.617 1.262 1.136.723 1.8 1.518 1.992 2.385.22.992.063 1.97-.471 2.932-.534.965-1.297 1.555-2.287 1.775-1.115.246-2.239.092-3.37-.471a394.466 394.466 0 0 1-4.228-2.133 14.257 14.257 0 0 0 1.114 2.823c.446.844.76 1.669.939 2.474.275 1.24.157 2.321-.352 3.247-.51.926-1.384 1.526-2.622 1.8-1.178.262-2.177.077-2.999-.554-.822-.629-1.37-1.563-1.646-2.803-.165-.743-.253-1.584-.267-2.525a33.804 33.804 0 0 0-.206-3.123c-1.129 1.357-2.065 2.555-2.809 3.597zM160.7 151.057c-.743 1.042-1.735 1.701-2.974 1.976-.991.22-1.933.007-2.823-.64-.892-.646-1.446-1.465-1.666-2.457-.193-.867.04-1.862.703-2.984.66-1.122 2.481-2.435 5.462-3.942-3.29-.18-5.484-.619-6.582-1.318-1.097-.697-1.742-1.482-1.935-2.35-.219-.99-.063-1.967.471-2.932.533-.962 1.296-1.555 2.288-1.775a4.938 4.938 0 0 1 3.521.486c1.108.6 2.459 1.274 4.056 2.024a34.064 34.064 0 0 0-1.134-2.917c-.385-.856-.653-1.625-.804-2.307-.276-1.239-.174-2.318.305-3.236.479-.919 1.306-1.509 2.483-1.77 1.238-.275 2.28-.116 3.128.477.847.591 1.407 1.508 1.683 2.746.179.806.243 1.686.195 2.637-.049.954.012 1.965.185 3.03a148.94 148.94 0 0 1 2.939-3.674c.795-.957 1.75-1.559 2.865-1.806.991-.22 1.932-.005 2.824.64.89.649 1.446 1.468 1.666 2.457.192.869-.076 1.855-.806 2.958-.73 1.105-2.548 2.434-5.452 3.989 3.275.118 5.482.539 6.617 1.262 1.136.723 1.799 1.518 1.992 2.385.22.992.062 1.97-.471 2.932-.534.965-1.297 1.555-2.287 1.775-1.116.247-2.239.092-3.371-.471a361.092 361.092 0 0 1-4.227-2.133 14.267 14.267 0 0 0 1.114 2.824c.446.844.759 1.669.938 2.473.276 1.24.158 2.322-.351 3.247-.51.927-1.384 1.526-2.623 1.8-1.177.262-2.176.078-2.998-.553-.822-.63-1.37-1.563-1.646-2.803-.165-.744-.254-1.585-.267-2.525a34.2 34.2 0 0 0-.206-3.124c-1.129 1.357-2.065 2.555-2.809 3.597zM198.334 142.704c-.743 1.042-1.735 1.701-2.974 1.977-.992.22-1.933.007-2.823-.641-.892-.645-1.447-1.465-1.666-2.457-.193-.867.04-1.861.702-2.983.661-1.122 2.482-2.436 5.463-3.943-3.29-.179-5.484-.619-6.582-1.317-1.098-.698-1.742-1.482-1.935-2.35-.22-.991-.064-1.968.471-2.932.533-.962 1.296-1.555 2.288-1.775a4.924 4.924 0 0 1 3.52.486 82.259 82.259 0 0 0 4.057 2.024 34.136 34.136 0 0 0-1.134-2.917c-.385-.856-.653-1.626-.805-2.308-.275-1.239-.173-2.317.306-3.236.479-.918 1.305-1.509 2.483-1.769 1.238-.276 2.28-.117 3.127.476.847.592 1.407 1.509 1.682 2.746.179.806.243 1.687.196 2.638a14.38 14.38 0 0 0 .184 3.029 153.337 153.337 0 0 1 2.939-3.674c.795-.956 1.75-1.559 2.866-1.806.99-.219 1.932-.005 2.823.641.89.648 1.446 1.468 1.666 2.457.193.868-.076 1.855-.806 2.958-.73 1.104-2.548 2.434-5.451 3.989 3.275.118 5.481.538 6.617 1.261 1.135.724 1.799 1.519 1.991 2.386.22.992.063 1.97-.47 2.932-.535.964-1.297 1.555-2.288 1.774-1.115.247-2.239.093-3.37-.47a404.157 404.157 0 0 1-4.228-2.133c.295 1.04.666 1.982 1.114 2.823.446.844.76 1.669.939 2.474.275 1.24.157 2.321-.352 3.246-.51.927-1.383 1.527-2.622 1.801-1.178.262-2.176.077-2.999-.554-.822-.629-1.37-1.563-1.645-2.803-.166-.743-.254-1.585-.268-2.525a33.458 33.458 0 0 0-.206-3.123c-1.129 1.357-2.065 2.555-2.808 3.597zM235.967 134.352c-.744 1.042-1.735 1.701-2.974 1.977-.992.219-1.934.006-2.824-.641-.891-.646-1.446-1.465-1.666-2.457-.192-.867.041-1.862.703-2.984.661-1.122 2.482-2.435 5.463-3.942-3.291-.179-5.485-.619-6.582-1.318-1.098-.697-1.742-1.481-1.935-2.35-.22-.99-.064-1.967.471-2.932.533-.962 1.296-1.555 2.287-1.774a4.93 4.93 0 0 1 3.521.485c1.109.6 2.46 1.274 4.057 2.025a34.136 34.136 0 0 0-1.134-2.917c-.386-.857-.653-1.626-.805-2.308-.275-1.239-.174-2.318.305-3.236.479-.919 1.306-1.509 2.483-1.77 1.239-.275 2.281-.116 3.128.477.846.591 1.407 1.508 1.682 2.746.179.806.243 1.686.196 2.637-.049.954.012 1.965.184 3.03a148.94 148.94 0 0 1 2.939-3.674c.795-.957 1.75-1.559 2.865-1.806.991-.22 1.932-.005 2.824.64.89.649 1.446 1.468 1.666 2.458.193.868-.076 1.854-.806 2.957-.73 1.105-2.548 2.434-5.453 3.989 3.275.118 5.482.539 6.617 1.262 1.136.723 1.799 1.518 1.992 2.385.22.992.062 1.97-.471 2.932-.534.965-1.297 1.555-2.287 1.775-1.116.247-2.239.092-3.371-.471a361.092 361.092 0 0 1-4.227-2.133 14.266 14.266 0 0 0 1.113 2.824c.447.844.76 1.669.939 2.473.276 1.24.158 2.322-.351 3.247-.51.927-1.384 1.526-2.623 1.8-1.177.262-2.176.078-2.998-.553-.822-.63-1.371-1.563-1.646-2.803-.165-.744-.254-1.585-.267-2.525a34.157 34.157 0 0 0-.206-3.123c-1.129 1.356-2.065 2.554-2.809 3.596z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.448,
    cy: 139.341,
    fill: "url(#illustration-otp-big_svg__e)",
    rx: 7.809,
    ry: 7.819
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.668,
    cy: 42.031,
    fill: "url(#illustration-otp-big_svg__f)",
    rx: 7.809,
    ry: 7.819
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-otp-big_svg__g)",
    strokeWidth: 1.955,
    d: "M283.652 86.804c0 3.78-3.06 6.841-6.832 6.841a6.836 6.836 0 0 1-6.832-6.841 6.836 6.836 0 0 1 6.832-6.841c3.772 0 6.832 3.062 6.832 6.841Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-otp-big_svg__h)",
    strokeWidth: 1.955,
    d: "M45.138 184.299c0 3.779-3.06 6.841-6.832 6.841a6.837 6.837 0 0 1-6.832-6.841c0-3.78 3.06-6.842 6.832-6.842s6.832 3.062 6.832 6.842Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 323.344,
    cy: 231.211,
    fill: "url(#illustration-otp-big_svg__i)",
    rx: 3.905,
    ry: 3.909
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.874,
    cy: 49.426,
    fill: "url(#illustration-otp-big_svg__j)",
    rx: 3.905,
    ry: 3.909
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.448,
    cy: 213.619,
    fill: "url(#illustration-otp-big_svg__k)",
    rx: 3.905,
    ry: 3.909
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.69,
    cy: 162.742,
    fill: "url(#illustration-otp-big_svg__l)",
    rx: 2.874,
    ry: 2.877
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.062,
    cy: 82.656,
    fill: "url(#illustration-otp-big_svg__m)",
    rx: 3.905,
    ry: 3.909
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#illustration-otp-big_svg__n)",
    strokeWidth: 1.955,
    d: "M287.225 135.432a2.93 2.93 0 0 1-2.927 2.932 2.93 2.93 0 0 1-2.928-2.932 2.93 2.93 0 0 1 2.928-2.932 2.93 2.93 0 0 1 2.927 2.932Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp-big_svg__o)",
    fillRule: "evenodd",
    d: "M312.5 110.884a.85.85 0 0 0-1.698-.005l-.007 2.211-2.205-.007a.85.85 0 0 0-.005 1.7l2.205.007-.007 2.21a.85.85 0 1 0 1.698.005l.007-2.21 2.207.007a.85.85 0 0 0 .005-1.7l-2.207-.007z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp-big_svg__p)",
    fillRule: "evenodd",
    d: "M309.694 156.384a.849.849 0 1 0-1.698-.005l-.006 2.21-2.206-.007a.85.85 0 0 0-.005 1.7l2.205.007-.006 2.211a.848.848 0 1 0 1.697.005l.007-2.211 2.206.007a.85.85 0 0 0 .006-1.7l-2.207-.007z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp-big_svg__q)",
    fillRule: "evenodd",
    d: "M93.94 76.678a.975.975 0 0 0-.99-.962.978.978 0 0 0-.963.991l.074 5.362-4.86.072a.978.978 0 0 0-.963.992c.007.54.45.97.99.962l4.86-.073.06 4.405c.008.539.451.97.99.962a.978.978 0 0 0 .964-.992l-.061-4.404 4.907-.074a.978.978 0 0 0 .963-.991.975.975 0 0 0-.99-.962l-4.907.074z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp-big_svg__r)",
    fillRule: "evenodd",
    d: "M38.195 128.704a.977.977 0 0 0-1.953.029l.073 5.362-4.86.072a.979.979 0 0 0-.963.992c.008.539.45.97.99.962l4.86-.073.06 4.404a.978.978 0 0 0 1.953-.029l-.06-4.404 4.907-.074a.976.976 0 1 0-.027-1.953l-4.906.073z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp-big_svg__s)",
    fillRule: "evenodd",
    d: "M302.839 197.868a.976.976 0 1 0-1.954.029l.074 5.362-4.86.072a.978.978 0 0 0 .027 1.954l4.86-.073.061 4.404a.977.977 0 0 0 1.953-.029l-.061-4.404 4.907-.074a.978.978 0 0 0 .963-.991.975.975 0 0 0-.99-.962l-4.906.073z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-otp-big_svg__t)",
    style: {
      mixBlendMode: "multiply"
    }
  }, _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 189.721,
    cy: 312.695,
    fill: "#E9E7F6",
    rx: 116.121,
    ry: 11.29
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.9,
    clipPath: "url(#illustration-otp-big_svg__u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp-big_svg__v)",
    d: "m92.28 288.407 188.48-101.1v101.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-otp-big_svg__w)",
    d: "m280.76 288.407-188.48-101.1v101.1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__a",
    x1: 185.991,
    x2: 185.991,
    y1: 86.822,
    y2: 285.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#9FBCFF",
    stopOpacity: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__b",
    x1: 185.991,
    x2: 185.991,
    y1: 86.822,
    y2: 285.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#9FBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__d",
    x1: 186.79,
    x2: 186.79,
    y1: -6.992,
    y2: 258.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#AEEA73",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__e",
    x1: 73.236,
    x2: 16.858,
    y1: 151.571,
    y2: 136.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__f",
    x1: 200.456,
    x2: 144.079,
    y1: 54.261,
    y2: 39.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__g",
    x1: 276.608,
    x2: 220.23,
    y1: 99.034,
    y2: 84.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__h",
    x1: 38.094,
    x2: -18.283,
    y1: 196.528,
    y2: 181.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__i",
    x1: 323.238,
    x2: 295.049,
    y1: 237.326,
    y2: 229.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__j",
    x1: 137.768,
    x2: 109.58,
    y1: 55.541,
    y2: 48.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__k",
    x1: 73.342,
    x2: 45.153,
    y1: 219.734,
    y2: 212.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__l",
    x1: 287.612,
    x2: 266.866,
    y1: 167.243,
    y2: 161.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__m",
    x1: 211.956,
    x2: 183.767,
    y1: 88.77,
    y2: 81.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__n",
    x1: 284.192,
    x2: 256.003,
    y1: 141.547,
    y2: 134.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__o",
    x1: 311.536,
    x2: 283.348,
    y1: 120.057,
    y2: 112.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__p",
    x1: 308.73,
    x2: 280.542,
    y1: 165.557,
    y2: 158.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__q",
    x1: 87.031,
    x2: 67.206,
    y1: 88.532,
    y2: 54.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__r",
    x1: 31.286,
    x2: 11.46,
    y1: 140.557,
    y2: 106.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__s",
    x1: 295.929,
    x2: 276.104,
    y1: 209.722,
    y2: 175.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEA73",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#AEEA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AEEA73",
    stopOpacity: 0.95
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__v",
    x1: 233.098,
    x2: 324.811,
    y1: 195.25,
    y2: 336.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#9FBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-otp-big_svg__w",
    x1: 186.52,
    x2: 111.056,
    y1: 187.307,
    y2: 346.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#9FBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-otp-big_svg__u"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M92.28 187.307h187.507v89.546c0 6.381-5.173 11.554-11.554 11.554H103.834c-6.381 0-11.554-5.173-11.554-11.554z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-otp-big_svg__t",
    width: 245.144,
    height: 35.481,
    x: 67.149,
    y: 294.954,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_8438_157778",
    stdDeviation: 3.226
  })))));
};
var Memo = /*#__PURE__*/memo(SvgIllustrationOtpBig);
export default Memo;